
<kendo-dialog-titlebar>
  <div style="font-size: 18px; line-height: 1.3em;">
    <span class="k-icon k-font-icon k-icon-xl k-i-form-element"></span> {{title}}
  </div>
</kendo-dialog-titlebar>

<form [formGroup]="editForm"  class="k-form-inline">

  <div class="k-form-field">
    <label class="form-label col-3 k-label" for="option">Question</label>
    <div class="col-8">
      <input type="text" id="option" formControlName="option" class="form-control" appAutoFocus>
      <div *ngIf="option?.invalid" class="alert alert-danger">
        <div *ngIf="option?.errors?.['required']">Question is required.</div>
      </div>
    </div>
  </div>


</form>

<kendo-dialog-actions>
  <button kendoButton (click)="onSaveAction()" class="btn btn-primary" [disabled]="editForm.invalid">Save</button>
  <button kendoButton (click)="onCancelAction()" class="btn btn-secondary">Cancel</button>
</kendo-dialog-actions>
